"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternalClientMessage = void 0;
const Either_1 = require("fp-ts/lib/Either");
const lodash_1 = require("lodash");
class InternalClientMessage {
    constructor(definition, channel) {
        this.handlers = [];
        this.handleAll = (handler) => {
            this.handlers.push({
                handler,
                filter: () => true,
                transient: false,
            });
        };
        this.handleSome = (handler, filter) => {
            this.handlers.push({
                handler,
                filter,
                transient: false,
            });
        };
        this.handleOne = (handler, filter) => {
            this.handlers.push({
                handler,
                filter,
                transient: true,
            });
        };
        this.send = (payload) => {
            this.channel.sendMessage(this.definition.id, payload);
        };
        this.dispatch = (message) => {
            const payload = this.decode(message.payload);
            const eligible = this.handlers.filter((handler) => handler.filter(payload));
            const transientEligible = eligible.filter((handler) => handler.transient);
            transientEligible.forEach((te) => lodash_1.pull(this.handlers, te));
            eligible.forEach((handler) => {
                try {
                    handler.handler(payload);
                }
                catch (e) {
                    console.error("Error occurred while handling message:", e);
                    console.error("Payload:", payload);
                }
            });
        };
        this.decode = (obj) => {
            const decoded = this.definition.type.decode(obj);
            if (!Either_1.isRight(decoded)) {
                throw Error("Invalid message content - doesn't satisfy type constraints for this message.");
            }
            return decoded.right;
        };
        this.definition = definition;
        this.channel = channel;
    }
}
exports.InternalClientMessage = InternalClientMessage;
//# sourceMappingURL=ClientMessage.js.map